<!-- Search Desktop-->
<div *ngIf="isDesktop" class="w-100">
    <div class="input-group w-100">
        <input class="form-control" type="search" [(ngModel)]="text" (keyup.enter)="onEnterEvent()" (search)="onEnterEvent()" (keyup)="onChangeEvent()"
        style="height: 45px !important; padding: 0px 20px !important;">
        <span class="input-group-append">
            <button class="btn btn-outline-secondary btn-search" type="button" 
            style="z-index: 0; height: 43px !important;">
                <i class="fa fa-search" (click)="onShowSearch()"></i>
            </button>
        </span>
    </div>
</div>

<!-- Search Mobile-->
<div *ngIf="!isDesktop" class="w-100">
    <div *ngIf="isInputVisible" class="input-group animated fadeInLeft w-100">
        <input class="form-control border-end-0 border rounded-pill" type="search" [(ngModel)]="text" (keyup.enter)="onEnterEvent()" (search)="onEnterEvent()" (keyup)="onChangeEvent()">
        <span class="input-group-append">
            <button class="btn btn-outline-secondary border-bottom-0 rounded-pill btn-search" type="button">
                <i class="fa fa-search" (click)="onShowSearch()"></i>
            </button>
        </span>
    </div>

    <div *ngIf="!isInputVisible" class="m-l-10 animated fadeInRight slower">
        <button class="btn btn-outline-secondary border-bottom-0 rounded-pill btn-search" type="button" style="margin-left: -10px;">
            <i class="fa fa-search" (click)="onShowSearch()"></i>
        </button>
    </div>
</div>
